var module = angular.module('main.resellerorder');

module.component('caResellerOrder', {
    templateUrl: 'main/resellerorder/resellerorderview/components/resellerordercontent.cmp.tpl.html',
    bindings: {
        orderId: '<',
        productNumberToExpand: '<'
    },
    controllerAs: 'vm',
    controller: componentController
});

// @ngInject
function componentController($translate, $state, loadSpinnerService, ToasterService, ResellerOrdersApiService, printLanguageConfirmationDialogService) {
    var vm = this;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    //Properties
    vm.resellerOrder = {};
    vm.showOrderHead = true;
    vm.tabSelection = {
        lineItems: true,
        fulfillments: false
    };
    vm.showOrderHead = true;
    vm.isEditingOrderNumber = false;
    vm.editedOrderNumber = '';


    //Methods
    vm.getStatusTranslation = getStatusTranslation;
    vm.changeToOrderRows = changeToOrderRows;
    vm.changeToFulfillmentsTab = changeToFulfillmentsTab;
    vm.toggleOrderHead = toggleOrderHead;
    vm.canPrintOrderPdf = canPrintOrderPdf;
    vm.getResellerOrderPdf = getResellerOrderPdf;
    vm.canPrintOrderCsv = canPrintOrderCsv;
    vm.getResellerOrderCsv = getResellerOrderCsv;

    vm.shouldShowPrintCsvButton = shouldShowPrintCsvButton;
    vm.getResellerOrderInvoicePdf = getResellerOrderInvoicePdf;
    vm.getResellerOrderDeliveryOrderPdf = getResellerOrderDeliveryOrderPdf;
    vm.getResellerOrderPickingList = getResellerOrderPickingList;
    vm.getResellerOrderDeliveryNotePdf = getResellerOrderDeliveryNotePdf;
    vm.DeliveryNoteAvailable = deliveryNoteAvailable;
    vm.createNewOrder = createNewOrder;
    vm.createNewReturnOrder = createNewReturnOrder;
    vm.editOrderNumber = editOrderNumber;
    vm.tryToSaveNewOrderNumber = tryToSaveNewOrderNumber;

    function onInit() {
    }

    function onChanges(change) {
        if (change.orderId && change.orderId.currentValue) {
            ResellerOrdersApiService.getOrderById(change.orderId.currentValue)
                .then(function (response) {
                    vm.resellerOrder = response.order;
                    vm.resellerOrder.links = response.links;
                });
        }
    }
    
    function editOrderNumber() {
        vm.isEditingOrderNumber = true;
        vm.editedOrderNumber = vm.resellerOrder.orderNumber;
    }

    function tryToSaveNewOrderNumber() {
        vm.isEditingOrderNumber = false;
        if(vm.editedOrderNumber === vm.resellerOrder.orderNumber){
            ToasterService.showError($translate.instant('productimport.noChangesToSave') + ' ' + angular.lowercase($translate.instant('common.in') + ' ' + $translate.instant('resellerorder.orderNumber') + '!'));
            return;
        }
        
        loadSpinnerService.start('mainSpinner');
        ResellerOrdersApiService.changeOrderNumber(vm.editedOrderNumber, vm.resellerOrder.id).then(function () {
            vm.resellerOrder.orderNumber = vm.editedOrderNumber;
            ToasterService.showSuccess($translate.instant('common.new') + ' ' + angular.lowercase($translate.instant('resellerorder.orderNumber')) + ': "' + vm.editedOrderNumber + '" ' + angular.lowercase($translate.instant('common.wasSaved') + '!'));
        }, function (error){
            vm.isEditingOrderNumber = true;
            ToasterService.showError(error.message);
        }).finally(function(){
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function createNewOrder() {
        $state.go('resellerorder.resellerordercreate');
    }

    function createNewReturnOrder() {
        $state.go('resellerorder.resellerreturnordercreate');
    }

    function changeToOrderRows() {
        setNoTabSelection();
        vm.tabSelection.lineItems = true;
    }

    function changeToFulfillmentsTab() {
        setNoTabSelection();
        vm.tabSelection.fulfillments = true;
    }

    function setNoTabSelection() {
        var keys = Object.keys(vm.tabSelection);
        _.forEach(keys, function (key) {
            vm.tabSelection[key] = false;
        });
    }

    function toggleOrderHead() {
        vm.showOrderHead = !vm.showOrderHead;
    }

    function getStatusTranslation(text) {
        if (!text) {
            return "";
        }
        var textCapital = text.substr(0, 1).toUpperCase() + text.substr(1, text.length - 1);
        return $translate.instant('resellerorder.status' + textCapital);
    }

    function canPrintOrderPdf() {
        var hasLink = _.find(vm.resellerOrder.links, function (o) { return o.rel === 'canPrintPdf'; }) !== undefined;
        return hasLink;
    }
    function getResellerOrderPdf() {
        printLanguageConfirmationDialogService.showDialog($translate.instant('order.printdisplayed') + ' PDF?').then(function (result) {
            if (result.result === true) {
                loadSpinnerService.start('mainSpinner');
                ResellerOrdersApiService.getResellerOrderPdf(vm.orderId, result.locale).then(function (response) {
                }, function (error) {
                    ToasterService.showError(error.message);
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }
    function canPrintOrderCsv() {
        var hasLink = _.find(vm.resellerOrder.links, function (o) { return o.rel === 'canPrintCsv'; }) !== undefined;
        return hasLink;
    }
    function getResellerOrderCsv() {
        printLanguageConfirmationDialogService.showDialog($translate.instant('order.printdisplayed') + '?').then(function (result) {
            if (result.result === true) {
                loadSpinnerService.start('mainSpinner');
                ResellerOrdersApiService.getResellerOrderCsv(vm.orderId, result.locale).then(function (response) {
                }, function (error) {
                    ToasterService.showError(error.message);
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function getResellerOrderInvoicePdf() {
        printLanguageConfirmationDialogService.showDialog($translate.instant('order.printdisplayed') + '?').then(function (result) {
            if (result.result === true) {
                var request = {
                    locale: result.locale
                };
                loadSpinnerService.start('mainSpinner');
                ResellerOrdersApiService.getResellerOrderInvoice(request).then(function (response) {
                }, function (error) {
                    ToasterService.showError(error.message);
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function getResellerOrderDeliveryOrderPdf() {
        printLanguageConfirmationDialogService.showDialog($translate.instant('order.printdisplayed') + '?').then(function (result) {
            if (result.result === true) {
                var request = {
                    locale: result.locale
                };
                loadSpinnerService.start('mainSpinner');
                ResellerOrdersApiService.getResellerOrderDeliveryOrder(request).then(function (response) {
                }, function (error) {
                    ToasterService.showError(error.message);
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function getResellerOrderPickingList() {
        printLanguageConfirmationDialogService.showDialog($translate.instant('order.printdisplayed') + '?').then(function (result) {
            if (result.result === true) {
                var request = {
                    resellerOrderIds: [vm.orderId],
                    locale: result.locale
                };
                loadSpinnerService.start('mainSpinner');

                ResellerOrdersApiService.getResellerOrderOrderPerspectivePickingList(request).then(function (response) {
                }, function (error) {
                    ToasterService.showError(error.message);
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function getResellerOrderDeliveryNotePdf() {
        printLanguageConfirmationDialogService.showDialog($translate.instant('order.printdisplayed') + '?').then(function (result) {
            if (result.result === true) {
                var request = {
                    resellerOrderIds: [vm.orderId],
                    locale: result.locale
                };
                loadSpinnerService.start('mainSpinner');

                ResellerOrdersApiService.getResellerOrderDeliveryNote(request).then(function (response) {
                }, function (error) {
                    ToasterService.showError(error.message);
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function deliveryNoteAvailable(){
        return (vm.resellerOrder.status === 'Open')
    }

    function shouldShowPrintCsvButton() {
        return vm.resellerOrder.currencyCode === 'SEK';
    }
}
